import moment from "moment";
import Modal from "../../../../../components/Modal";
import {
  BodyContainer,
  Child,
  CloseBtn,
  Container,
  Header,
  HeaderContainer,
  ModalContainer,
  TitleContainer,
} from "../style";
import { TableContainer } from "../../../../../components/DashboardComps/Dashboard.styles";
import DynamicGrid from "../../../../../components/DynamicGrid/DynamicGrid";
import {
  getDrilldownGridKey,
  useDrilldownSnapshot,
} from "../../drilldown/useDrilldownSnapshot";
import { incidentLists } from "../../dummyData/colums";
import { Fragment } from "react";
import { ChartContainer, NoData } from "../../style";
import { Bar } from "react-chartjs-2";
import { barOptions, barOptionsHorizontal } from "../formUtils";
import { BigBoldText } from "../../../dashboard/home/home.style";

type SectionModalProps = {
  open: boolean;
  facilityName: string;
  startDate: string;
  endDate: string;
  closeFn: (open: boolean) => void;
  resetFn: (value: string) => void;
  isLoading: boolean;
  tableData: any;
  title: string;
  getUserCallback: (item: any) => void;
  handlePdfExport: () => void;
  handleCsvExport: () => void;
  tableCols?: any;
};

const SectionModal = ({
  open,
  facilityName,
  startDate,
  endDate,
  closeFn,
  resetFn,
  isLoading,
  tableData,
  title,
  getUserCallback,
  handlePdfExport,
  handleCsvExport,
  tableCols,
}: SectionModalProps) => {
  const clearSnapshot = useDrilldownSnapshot("fall", {
    open,
    facilityName,
    startDate,
    endDate,
    title,
    tableData,
    tableCols,
  });

  return (
    <Modal open={open}>
      <ModalContainer>
        <HeaderContainer>
          <TitleContainer>
            <BigBoldText style={{ color: "#b580ff" }}>
              {" "}
              <span className="capitalize">{facilityName}</span>{" "}
            </BigBoldText>
            <div style={{ color: "#b580ff" }}>
              <p>
                {moment(startDate).format("LL")} -{" "}
                {moment(endDate).format("LL")}
              </p>
              <p>{title}</p>
            </div>
          </TitleContainer>
          <div style={{ display: "-webkit-inline-box" }}>
            <CloseBtn
              type="button"
              onClick={() => {
                clearSnapshot();
                closeFn(false);
                resetFn("");
              }}
            >
              &times;
            </CloseBtn>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <TableContainer>
            <DynamicGrid
              gridCols={tableCols || incidentLists()}
              gridData={tableData}
              showTitleBar={false}
              barTitle={`${facilityName} - ${title}`}
              includeIncidentLink={true}
              viewStateKey={getDrilldownGridKey("fall", {
                facilityName,
                title,
                startDate,
                endDate,
              })}
              startDate={startDate}
              endDate={endDate}
              showSearchBar={false}
              filterable={true}
              sortable={true}
            />
          </TableContainer>
        </BodyContainer>
      </ModalContainer>
    </Modal>
  );
};

export default SectionModal;

type DefaultContainerProps = {
  title: string;
  grid: any;
  handleBarClicked: any;
  barData: any;
  barType: string;
};

export const DefaultContainer = ({
  title,
  grid,
  handleBarClicked,
  barData,
  barType,
}: DefaultContainerProps) => {
  return (
    <Fragment>
      <Header>{title}</Header>
      <Container>
        <Child flex="40%">
          {grid}
        </Child>
        <Child flex="60%">
          <ChartContainer>
            {barData?.labels?.length > 0 ? (
              <Bar
                options={
                  barType === "horizontal"
                    ? barOptionsHorizontal(handleBarClicked)
                    : barOptions(handleBarClicked)
                }
                data={barData}
              />
            ) : (
              <NoData>No Data</NoData>
            )}
          </ChartContainer>
        </Child>
      </Container>
    </Fragment>
  );
};
